import React from 'react';
import PropTypes from 'prop-types';
import MaxWidthContainer from '../Containers/MaxWidthContainer';
import contentTypeName from '../../../utils/contentTypeName';

const EditContentLinks = ({ userId, authorId, contentId, contentType, cmsCreated }) => {
  let editLinks = null;
  if (userId) {
    if ((userId === authorId) && (cmsCreated === false)) {
      const type = contentTypeName(contentType);
      const listItemClass = 'btn btn--tertiary';
      const progressionLabel = contentType === 'pitchdiagram' ? `Add a progression` : `Duplicate content`;

      editLinks = (
        <div className="edit-content-links p-y-3 border-bottom-1 border-color-grey--light">
          <MaxWidthContainer>
            <ul className="inline-list">
              <li><a href={`/locker/my-content/${type}/${contentId}`} className={listItemClass}>Edit this {type}</a></li>
              <li><a href={`/locker/my-content/${type}/${contentId}?progression=true`} className={listItemClass}>{progressionLabel}</a></li>
            </ul>
          </MaxWidthContainer>
        </div>
      );
    }
  }

  return editLinks;
};

EditContentLinks.propTypes = {
  userId: PropTypes.number,
  authorId: PropTypes.number,
  contentId: PropTypes.number,
  contentType: PropTypes.string,
  cmsCreated: PropTypes.bool,
};

export default EditContentLinks;



// WEBPACK FOOTER //
// ./library/app/components/Global/Links/EditContentLinks.js